import React, { FC } from 'react';
import { Box, Text, HStack, VStack, Button } from '@chakra-ui/react';
import { formatPrice } from '@olo-web/domain/orders/functions/formatPrice';
import { useGiftCardBalance } from '@olo-web/domain/giftcard';
import { useCheckoutDispatch } from '@olo-web/client-state';
import { GiftCardIcon } from '@olo-web/assets/icons/payments/GiftCardIcon.ui';

type TGiftCardViewProps = {
  accessibilityProps?: Record<string, string>;
};

export const GiftCardView: FC<TGiftCardViewProps> = ({ accessibilityProps }) => {
  const { data: giftCard, remove } = useGiftCardBalance();
  const checkoutDispatch = useCheckoutDispatch();

  const removeGiftCard = () => {
    checkoutDispatch({
      type: 'CLEAR_GIFTCARD',
    });
    remove();
  };

  return (
    <Box w="100%">
      <Text mb={4} textStyle="pBold">
        Add gift card
      </Text>
      <HStack alignItems="flex-start" justifyContent={{ base: 'space-between', md: 'flex-start' }}>
        <GiftCardIcon h={6} w={10} />
        <VStack textStyle="p" align="flex-start" {...accessibilityProps}>
          <Text data-testid="added-gift-card-number">{`Gift card ${giftCard?.cardNumber}`}</Text>
          <Text data-testid="added-gift-card-balance">
            {formatPrice(giftCard?.remainingBalanceAmount)}
          </Text>
        </VStack>
        <Button
          onClick={removeGiftCard}
          variant="tertiary"
          textDecor="underline"
          fontWeight="normal"
          colorScheme="primary"
          pb={3}
          data-testid="remove-gift-card-button"
        >
          Remove
        </Button>
      </HStack>
    </Box>
  );
};
